import { useEffect, useState } from "react";
import { ShieldAlert, MessageCircle } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

export default function Blocked() {
  const { logout } = useAuth();
  const [supportUrl, setSupportUrl] = useState("https://t.me/my_kupidon_bot");

  useEffect(() => {
    let alive = true;
    api.get("/support/contact")
      .then(({ data }) => {
        if (!alive) return;
        if (data?.support_url) setSupportUrl(data.support_url);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="kupidon-shell safe-top safe-bottom flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-3xl bg-white border border-[color:var(--border)] p-6 text-center shadow-sm">
        <div className="w-16 h-16 rounded-2xl bg-red-50 mx-auto flex items-center justify-center mb-4">
          <ShieldAlert className="w-8 h-8 text-red-500" />
        </div>
        <div className="font-[Onest] font-extrabold text-2xl">К сожалению, вы заблокированы</div>
        <p className="text-sm text-[color:var(--ink-soft)] mt-2">
          Доступ к приложению ограничен. Если это ошибка, свяжитесь с поддержкой.
        </p>

        <a
          href={supportUrl}
          target="_blank"
          rel="noreferrer"
          className="btn-pill mt-5 w-full bg-[color:var(--ink)] text-white inline-flex items-center justify-center gap-2"
        >
          <MessageCircle className="w-4 h-4" />
          Связаться с поддержкой
        </a>

        <button
          onClick={logout}
          className="mt-3 text-sm text-[color:var(--ink-soft)] underline"
        >
          Выйти
        </button>
      </div>
    </div>
  );
}
